"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Constant = require("../../Constant");

var _theme;

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n  padding: 0;\n  border: none;\n\n  /* focus-within is used to target the <label> because CSS does not have a previous sibling selector */\n  &:focus-within {\n    legend {\n      ", "\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var focusStyles = (0, _styledTheming.default)('mode', (_theme = {
  caliber: "color: ".concat(_Constant.Color.CALIBER_BLUE_NEW, ";")
}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, "color ".concat(_Constant.Color.HOMEBRIDGE_BLUE)), (0, _defineProperty2.default)(_theme, "homepoint", "color: ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, "color: ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK, ";")), (0, _defineProperty2.default)(_theme, "figure", "color: ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme, "pella", "color: ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme, "petersendean", "color: ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "color: ".concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";")), _theme));

var Element = _styledComponents.default.fieldset(_templateObject(), focusStyles);

var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  return /*#__PURE__*/_react.default.createElement(Element, props, children);
};

Fieldset.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Fieldset;
exports.default = _default;